import { z } from 'zod'

/** Les trois funnels de l'écran de choix (#356) : une liste, un PDF de vente, des PDF par lot. */
export const IMPORT_MODES = ['list', 'pdf-unit', 'pdf-batch'] as const

export type ImportMode = (typeof IMPORT_MODES)[number]

/**
 * Les `search params` de « Imports » : le funnel choisi, et le client déjà choisi quand on arrive de
 * sa fiche (« Importer un lot »). Un identifiant illisible se lit comme « aucun client » (M21
 * appliqué à l'URL) : l'assistant le fait alors choisir, comme d'ordinaire ; un funnel inconnu
 * ramène à l'écran de choix.
 */
export const importSearchSchema = z.object({
  mode: z.enum(IMPORT_MODES).optional().catch(undefined),
  client: z.string().min(1).optional().catch(undefined),
})

export type ImportSearch = z.infer<typeof importSearchSchema>
